import useSWR from "swr";
import fetcher from "./fetcher";

export default function usePolicyAdmin(slug) {
  const { data, isLoading, error, mutate } = useSWR(
    slug ? `/api/policy/admin/${encodeURIComponent(slug)}` : null,
    fetcher,
  );

  return {
    policy: data ?? null,
    isLoading,
    isError: Boolean(error),
    error,
    mutate,
  };
}
